<template>
	<div id="news_window" @touchmove.stop.prevent="" class="action-window">
		<div class="container xsqcon">
			<!-- <div class="close" @click="newsClickHandler"></div> -->
			<!-- <div class="img">
				<img class="xsq" src="../../image/new-guild.png" alt="" />
			</div> -->
				<!--<div class="user-method">
					<div class="all-user">
						对所有老师有效
					</div>
					<div class="expired-time">
						有效期至:2018.08.06
					</div>
                </div>-->
				<div class="prize-show">
					<div class="prize-row">
						<span class="prize-amount" >
							<template v-if="!Number(newUserObj.data.discount)">
								<span>￥</span><span class="coupon-value">{{ newUserObj.data.amount | moneyFormat }}</span
								>
							</template>
							<template v-else>
								<span>{{newUserObj.data.discount.replace(/^(\d+)\.0+$/, '$1')}}折券</span>
							</template>
						</span>
						<span class="prize-name">
							<template v-if="newUserObj.data.teacher_info && newUserObj.data.teacher_info.nickname">
								<img class="prize-avatar" :src="newUserObj.data.teacher_info.avatar" alt="">
								<span class="prize-teacher">{{newUserObj.data.teacher_info.nickname}}</span>
							</template>
							<span class="name-txt">
								{{newUserObj.data.name}}
							</span>
						</span>
					</div>
					<div class="prize-row">
						<span class="coupon-tip">满{{ newUserObj.data.mininum | moneyFormat }}可用</span>
						<span class="prize-end">有效期至:{{newUserObj.data.end_time_format}}</span>
					</div>
				</div>
				<div
					class="guild-btn"
					@click.stop.prevent="newsClickHandler(newUserObj.data)"
				>
					立即使用
				</div>
		</div>
	</div>
</template>

<script>
import {apiPath} from '../../common/js/config.js';
import myAjax from '../../common/js/request';
import {commonFn} from '../../common/js/common';
export default {
    name: 'newUserPopLink',
    props: ['newUserObj'],
    data() {
        return {
            channel: commonFn.getParams()['channel'] || localStorage.getItem('channel') || ''
        };
    },
    filters: {
        moneyFormat: commonFn.formateMoney
    },
    computed: {
        isForceRegister() {
            return this.$store.state.isForceRegister;
        }
    },
    methods: {
        async newsClickHandler(info) {
            // range: {
            // 	1: '全部',
            // 	2: '普通问题',
            // 	3: '闪测',
            // 	4: '高级服务',
            // 	5: '专题',
            // 	6: '课程',
            // 	7: '社群课程',
            // 	8: '商城商品',
            // },
            let url = info.url;
            let type = info.range;

            if (url) {
                if (!url.startsWith('http')) {
                    if (url[0] != '/') {
                        url = '/' + url;
                    }
                    url = location.origin + url;
                }
                this.$emit('close', true);
                location.href = url;
                return;
            }

            /* 跳转闪测 */
            if (this.$route.path == '/seckill') {
                this.$emit('close');
                return false;
            } else if (this.$route.path == '/ScDetail') {
                this.$emit('close');
                return false;
            } else if (info.teacher_info && info.teacher_info.uid) {
                this.$emit('close', true);
                this.$router.push({path: `/answerIndex?answer_uid=${info.teacher_info.uid}`});
            } else if (type === 2 || type === 4) {
                this.$emit('close', true);
                this.$router.push({
                    path: `/usercateList`
                });
            } else if (type === 3) {
                this.$emit('close', true);
                this.$router.push({
                    path: `/scIndex`
                });
            } else if (info.range === 8 || info.range === 6) {
                this.$emit('close', true);
                this.$router.push({path: '/mallIndex'});
            } else if (url) {
                this.$emit('close', true);
                location.href = url;
            } else {
                this.$emit('close');
                return false;
            }
            _hmt.push(['_trackPageview', '/new-duanxinlianjie']);
        }
    },
    mounted() {}
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '../../common/style/config.less';
/* 首页活动弹窗 */
.action-window {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10000;
    background: rgba(0, 0, 0, 0.7);
}
.action-window .container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 7.173rem;
    height: 5.107rem;
    background: url('../../image/coupon/bg_coupon_box.png') center/100% no-repeat;
    transform: translate(-50%, -50%);
    border-radius: 0.067rem 0.067rem;
}
.action-window .container img {
    vertical-align: middle;
}
.xsqcon {
    padding-top: 1.040rem;
}
.action-window .close {
    position: absolute;
    right: 0.267rem;
    top: 0.267rem;
    width: 0.400rem;
    height: 0.400rem;
    background: url(../../image/close-new-guild.png) no-repeat center center;
    background-size: 0.400rem 0.400rem;
}
.user-method {
    display: flex;
    justify-content: space-between;
    padding: 0.267rem 0;
    border-bottom: 1px dashed #eee;
    font-size: 0.320rem;
}
.prize-show {
    display: flex;
    width: 6.987rem;
    height: 2.133rem;
    background: url('../../image/coupon/bg_coupon.png') center/100% no-repeat;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0.133rem 0.267rem 0.347rem;
    margin: 0 auto;
    .prize-row {
        display: flex;
        align-items: center;
        width: 100%;
        .prize-avatar {
            width: 0.480rem;
            height: 0.480rem;
            border-radius: 50%;
            margin-right: 0.080rem;
            vertical-align: middle;
        }
        .prize-teacher {
            font-size: 0.400rem;
            margin-right: 0.133rem;
            color: #333333;
            font-weight: 700;
            line-height: 0.400rem;
            vertical-align: middle;
        }
        .prize-name {
            flex: 1;
            font-size: 0.400rem;
            color: #333333;
            font-weight: 700;
            padding-left: 0.373rem;
            flex-wrap: nowrap;
            .line-ellipsis(1);
            font-size: 0;
            display: flex;
            align-items: center;
            span {
                vertical-align: middle;
                font-size: 0.400rem;
            }
            .name-txt {
                .line-ellipsis(1);
                flex: 1;
            }
        }
        .prize-amount {
            width: 1.733rem;
            text-align: center;
            span {
                font-size: 0.400rem;
                color: #ba1818;
                font-weight: 700;
            }
            .coupon-value {
                color: #ba1818;
                font-size: 0.480rem;
                margin-left: -0.053rem;
            }
        }

        .coupon-tip {
            font-size: 0.267rem;
            color: #d83535;
            width: 1.733rem;
            text-align: center;
        }
        .prize-end {
            flex: 1;
            font-size: 0.267rem;
            color: #666666;
            padding-left: 0.373rem;
        }
    }
    .prize-tip {
        display: inline-flex;
        align-items: baseline;
        font-size: 0.400rem;
        color: #fffefe;
    }
}
.guild-btn {
    width: 5.493rem;
    height: 1.067rem;
    line-height: 1.067rem;
    text-align: center;
    font-size: 0.427rem;
    color: #762525;
    font-weight: 700;
    background: linear-gradient(180deg, #ffefd0 0%, #fcd25f 100%);
    opacity: 1;
    border-radius: 0.533rem;
    margin: 0.480rem auto 0;
}
</style>



// WEBPACK FOOTER //
// newUserPopLink.vue?18127a74